var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"alt":_vm.altText,"src":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }